var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContectSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "me-2",
    width: 14,
    height: 14,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62574",
    "data-name": "Group 62574",
    transform: "translate(18757 19347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_245",
    "data-name": "Mask Group 245",
    transform: "translate(-26767 -1959)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62573",
    "data-name": "Group 62573",
    transform: "translate(8011.677 -17387.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26478",
    "data-name": "Path 26478",
    d: "M-395.812,272.315a4.256,4.256,0,0,1-4.24-4.262,4.265,4.265,0,0,1,4.294-4.253,4.263,4.263,0,0,1,4.238,4.267A4.251,4.251,0,0,1-395.812,272.315Zm.025-7.392a3.136,3.136,0,0,0-3.137,3.12,3.155,3.155,0,0,0,3.141,3.165,3.155,3.155,0,0,0,3.138-3.168A3.137,3.137,0,0,0-395.787,264.923Z",
    transform: "translate(403.108 -263.8)",
    fill: "#ff295c",
    stroke: "#ff295c",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26479",
    "data-name": "Path 26479",
    d: "M-410.249,307.377c-.111.007-.225.02-.339.021-.257,0-.514,0-.826,0a7.239,7.239,0,0,1,3.293-6.089,7.232,7.232,0,0,1,8.128.044,7.245,7.245,0,0,1,3.225,6.045c-.326,0-.6,0-.867,0-.1,0-.2-.017-.3-.026a6.246,6.246,0,0,0-6.157-6.092A6.252,6.252,0,0,0-410.249,307.377Z",
    transform: "translate(411.415 -290.324)",
    fill: "#ff295c",
    stroke: "#ff295c",
    strokeWidth: 0.35
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContectSvg);
export default __webpack_public_path__ + "static/media/contect-svg.8614bba69298b1874c6bee09e9e95dd7.svg";
export { ForwardRef as ReactComponent };